import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dnsimple = defineConnector({
  identifier: "dnsimple",
  name: "DNSimple",
  tagLine: "DNS hosting and domain management",
  logo,
  protocol: "http",
  tags: ["it", "engineering"],
  defaultUrlPattern: () => "https://api\\.dnsimple\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [DNSimple](https://dnsimple.com/user), navigate to **Account > Access Tokens**, and generate a new token.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.dnsimple.com/v2/whoami",
  },
});
